import Util from '@/helper/Utility.js';

export function CollectPointModel(key, value) {
    this.code = key;
    this.detail = Util.isJson(value.detail) ? Util.jsonParse(value.detail) : value.detail;
    this.points = value.points || null;
    this.points_earn = value.points_earn || null;
    this.status = value.status || null;
}